module.exports = __webpack_public_path__ + "static/img/banneren-CqoSed6l.458b5b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/banneren-CqoSed6l.png
// module id = M/Sn
// module chunks = 16